export default __webpack_public_path__ + "static/media/plus.1af0c354.svg";